import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    rmCode: {
        name: () => "需求域"
    },
    rmName: {
        name: () => "需求域",
        disabled: () => true,
    },
    brfTitle: {
        name: () => '结构化需求单标题',
    },
    // brfModeName: {
    //     name: () => '结构化需求单模式',
    //     readOnly: () => true,
    //     disabled: () => true,
    // },
    bizNo: {
        name: () => '业务需求单编号',
    },
    resume:  {
        name: () => '结构化需求单简述',
    },
    production_window: { 
        name: () => '投产期编号',
        readOnly: () => true,
        disabled: () => true,
    },
    producttion_start_date: {
        name: () => '投产起始日期',
        readOnly: () => true,
        disabled: () => true,
    },
    producttion_end_date: {
        name: () => '投产截止日期',
        readOnly: () => true,
        disabled: () => true,
    },

    brfCode: {
        name: () => '结构化需求单编号',
        readOnly: () => true,
        disabled: () => true,
    },
    crtName: {
        name: () => '创建人',
        readOnly: () => true,
        disabled: () => true,
    },

    crtTime: {
        name: () => '创建时间',
        readOnly: () => true,
        disabled: () => true,
    },
    mrmId: {
        name: () => '需求经理',
    },
    mrmName: {
        name: () => '需求经理',
        readOnly: () => true,
        disabled: () => true,
    },
    mbmName: {
        name: () => '主牵业务经理',
        readOnly: () => true,
        disabled: () => true,
    },

    mtmId: {
        name: () => '主牵技术经理',
    },
    mtmName: {
        name: () => '主牵技术经理',
        readOnly: () => true,
        disabled: () => true,
    },

})
